import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({ increment, counter, moamad }) {
  const [newMoamadootNote, setNewMoamadootNote] = useState({
    note: null,
    moamad: moamad.id,
  });
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewMoamadootNote((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "moamadootnote/",
          newMoamadootNote,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  // render
  return (
    <div>
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            <h3>
              תיעוד/הערה של: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
            </h3>
          </div>
          <div className="card-body">
            <Row>
              <Col>
                <form onSubmit={handleSubmit} className="mbsc-form-group">
                  {" "}
                  <div className="form-group">
                    <label htmlFor="note">הערה/תיעוד</label>
                    <textarea
                      rows="4"
                      cols="50"
                      name="note"
                      value={newMoamadootNote.note}
                      onChange={handleChange}
                      className="form-control"
                      id="note"
                    />
                  </div>
                  <br />
                  <button type="submit" className="btn btn-primary">
                    הוסף
                  </button>
                </form>
              </Col>
            </Row>
          </div>
        </div>
      </center>
    </div>
  );
}
